/* eslint-disable */
// ---------------------------------------------------------
// GENERATED FILE — DO NOT EDIT.
// Source: functions/src/serviceEngine/
// Regenerate with: npm run gen:engine
// ---------------------------------------------------------

// Canonical Service Engine — timezone conversion.
//
// Phase 1 Workstream C: DEFECT CORRECTION (documented; NOT a neutral extraction).
//
// Defect: the legacy checkin.js getDatePartsInTimeZone returned hour 24 for local
// midnight (this Node/ICU runtime's Intl.DateTimeFormat emits "24" with
// hour12:false). Fed through buildDateFromPartsInTimeZone, a service whose start
// hour equals the zone's UTC offset (e.g. 06:00 America/Chicago, 08:00
// America/Los_Angeles) was materialized on the PREVIOUS local day.
//
// Correction: adopt the hardened implementation (hour === 24 -> 0, plus a
// null-date guard), which matches the variant already used by
// canonicalCheckinResolver.js. Reachable via the free <input type="time"> in both
// admin editors; no current production organization relies on the legacy
// behavior (CLMI & RCCG Sunday services are at 09:00). Covered by a dedicated
// regression test (America/Chicago 06:00 must materialize the correct local day).

const DEFAULT_ORG_TIMEZONE = "America/Los_Angeles";

function toDate(value) {
  if (!value) return null;
  if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value;
  if (typeof value.toDate === "function") {
    const date = value.toDate();
    return Number.isNaN(date.getTime()) ? null : date;
  }
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

function getDatePartsInTimeZone(date, timeZone = DEFAULT_ORG_TIMEZONE) {
  const safeDate = toDate(date) || new Date();
  const formatter = new Intl.DateTimeFormat("en-US", {
    timeZone: timeZone || DEFAULT_ORG_TIMEZONE,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
  const parts = formatter.formatToParts(safeDate);
  const map = {};
  parts.forEach((part) => {
    if (part.type !== "literal") map[part.type] = part.value;
  });
  const hour = Number(map.hour);
  return {
    year: Number(map.year),
    month: Number(map.month),
    day: Number(map.day),
    hour: hour === 24 ? 0 : hour,
    minute: Number(map.minute),
  };
}

function buildDateFromPartsInTimeZone(year, month, day, hour, minute, timeZone = DEFAULT_ORG_TIMEZONE) {
  const utcGuess = new Date(Date.UTC(year, month - 1, day, hour, minute, 0));
  const guessParts = getDatePartsInTimeZone(utcGuess, timeZone);
  const guessUtcMinutes =
    Date.UTC(
      guessParts.year,
      guessParts.month - 1,
      guessParts.day,
      guessParts.hour,
      guessParts.minute
    ) /
    (1000 * 60);
  const targetUtcMinutes = Date.UTC(year, month - 1, day, hour, minute) / (1000 * 60);
  return new Date(utcGuess.getTime() + (targetUtcMinutes - guessUtcMinutes) * 60 * 1000);
}

export {
  DEFAULT_ORG_TIMEZONE,
  toDate,
  getDatePartsInTimeZone,
  buildDateFromPartsInTimeZone,
};
